/*
 * @Author: edvardchen
 * @Date:   2016-10-23 12:35:33
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-26 18:31:02
 */

// @flow
import React from 'react';

const colorTypeMap = [
  'mod-feed-tagline__word', // gray
  'mod-feed-tagline__tag-orange', // red
  'mod-feed-tagline__tag-blue', // blue
  'mod-feed-tagline__word', // black
];

export default function MediaLabel({ text, colorType = 0 }: { text: string, colorType: number }) {
  return <span className={colorTypeMap[colorType]}>{text}</span>;
}
